import { BASE_URL } from '../utils/constant';
import { localStore } from '../App';

class SignsService 
{
  async fetchSigns(): Promise<any> 
  {
    const remoteSigns = await this.fetchRemoteSigns();
    if (remoteSigns) 
    {
      console.log('fetchSigns:: Informazioni sulla segnaletica scaricarte dal server.');
      return remoteSigns;
    }
    return this.fetchSignsFromStorage();
  }

  async fetchSignsFromStorage(): Promise<any> 
  {
    try 
    {
      console.log('fetchSignsFromStorage:: cerco informazioni sulla segnaletica in memoria');
      const signs = await localStore.get("signlist");
      if (signs != null) 
      {
        console.log('fetchSignsFromStorage:: Informazioni sulla segnaletica presenti in memoria.');
        return signs;
      }

      console.log('Non sono presenti informazioni sulla segnaletica in memoria - riavviare l\'app e  riprovare');
      return null;
    }
    catch (error) 
    {
      console.log('Problema nella ricezione dei dati sulla segnaletica - riavviare l\'app e riprovare ', error);
      throw error;
    }
  }
  
  async fetchRemoteSigns(): Promise<[any] | null> 
  {
    console.log('fetchRemoteSigns:: cerco segnaletica sul server');
    return new Promise((resolve, reject) => {
      const url = `${BASE_URL}/poServer.php?act=18&h=gkzLoFk0MN58TGqCJj`;
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => 
          {
            console.log('fetchRemoteSigns :: Informazioni sulla segnaletica scaricarte dal server.');
            localStore.set('signlist', result.content);
            console.log('fetchRemoteSigns :: Scaricati in totale  ', result.content.length, ' segnali dal server');
            resolve(result.content);
          },
          (error) => {
            console.log('fetchRemoteSigns :: Problema nella ricezione dei dati sulla segnaletica - controlliamo se ce ne sono in memoria ', error);
            resolve(null);
          }
        );
    });
  }

  async deleteSign(index: number, userToken: string): Promise<any> 
  {
    const url = `${BASE_URL}/poServer.php?h=gkzLoFk0MN58TGqCJj&act=19`;
    const formData = new FormData();
    formData.append('id', index.toString());
    formData.append('userToken', userToken);
    formData.append('h', 'gkzLoFk0MN58TGqCJj');
    formData.append('act', '19');
    // console.log('deleteSign :: id: ' + index.toString());

    const response = await fetch(url, {
      method: 'DELETE',
      mode: 'cors', // this has to be 'cors'
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    });

    console.log('deleteSign :: response: ', response);
    return response.json();
  }

  async updateSignPosition(signId: number, position: { latitude: number, longitude: number }, userToken: string) {
    const formData = new FormData();
    formData.append("user_token", userToken);
    formData.append("sign_id", signId.toString());
    formData.append("point_lat", JSON.stringify(position.latitude));
    formData.append("point_lng", JSON.stringify(position.longitude));
    
    const url = `${BASE_URL}/poServer.php?h=gkzLoFk0MN58TGqCJj&act=112`; // Use appropriate endpoint
    
    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        body: formData,
        headers: {
            'Accept': 'application/json'
        }
    });
    
    const data = await response.json();
    if (data.code !== 200) {
        throw new Error(data.error || 'Failed to update position');
    }
    
    return data;
  }
}

export default SignsService; 